import React from 'react';
import './home.css';
import HeaderSocials from './HeaderSocials';

const Home = () => {
    return (


        <section className="home container" id="home">

            <div className="intro">


                <HeaderSocials />
                <a href="#contact" className="btn__home">Contact Me</a>



            </div>


        </section>


    );
};

export default Home;